export const c_card_m_selectable_raised_m_selected_raised_TranslateY_base = {
  "name": "--pf-c-card--m-selectable-raised--m-selected-raised--TranslateY--base",
  "value": "-0.5rem",
  "var": "var(--pf-c-card--m-selectable-raised--m-selected-raised--TranslateY--base)"
};
export default c_card_m_selectable_raised_m_selected_raised_TranslateY_base;